export default function Logo({ className = "h-8 w-8", testid }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="My Fresh Tracker logo"
      data-testid={testid}
    >
      <circle cx="32" cy="32" r="30" fill="#1F9D55" />
      <path d="M46 18C32 19 22 29 20 43c14-1 24-11 26-25Z" fill="#FFFFFF" />
      <path
        d="M28 33.5l4 4L38.5 26"
        fill="none"
        stroke="#1F9D55"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
